<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Edytuj opcję</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li>
          <router-link to="/product-option-group/list">Grupy opcji</router-link>
        </li>
        <li>
          <router-link :to="`/product-option-group/${groupPk}/options`">
            {{ groupName }}
          </router-link>
        </li>
        <li class="active">
          <strong>Edycja</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <form
      class="form-horizontal"
      method="POST"
      name="form"
      role="form"
      @submit.prevent="updateOption"
    >
      <div class="has-error" v-if="serverErrors.nonFieldErrors">
        <span
          class="help-block"
          v-for="error in serverErrors.nonFieldErrors"
          :key="error"
        >
          {{ error }}
        </span>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="ibox" :class="{ collapsed: !expandedSections.pl }">
            <div class="ibox-title">
              <h5>Opis opcji [pl]</h5>
              <div class="ibox-tools">
                <a class="collapse-link" @click="toggleSection('pl')">
                  <i
                    :class="
                      expandedSections.pl
                        ? 'fa fa-chevron-up'
                        : 'fa fa-chevron-down'
                    "
                  ></i>
                </a>
              </div>
            </div>

            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Etykieta</label>
                <div class="col-sm-10">
                  <input
                    v-model="optionData.label_pl"
                    name="label_pl"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Etykieta"
                    required
                  />
                  <div v-if="serverErrors.label_pl" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.label_pl"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Opis</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="optionData.description_pl"
                  />
                  <div v-if="serverErrors.description_pl" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.description_pl"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Opis wewnętrzny</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="optionData.internal_description"
                  />
                  <div
                    v-if="serverErrors.internal_description"
                    class="has-error"
                  >
                    <span
                      class="help-block"
                      v-for="error in serverErrors.internal_description"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="ibox" :class="{ collapsed: !expandedSections.en }">
            <div class="ibox-title">
              <h5>Opis opcji [en]</h5>
              <div class="ibox-tools">
                <a class="collapse-link" @click="toggleSection('en')">
                  <i
                    :class="
                      expandedSections.en
                        ? 'fa fa-chevron-up'
                        : 'fa fa-chevron-down'
                    "
                  ></i>
                </a>
              </div>
            </div>

            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Etykieta</label>
                <div class="col-sm-10">
                  <input
                    v-model="optionData.label_en"
                    name="label_en"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Etykieta"
                  />
                  <div v-if="serverErrors.label_en" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.label_en"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Opis</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="optionData.description_en"
                  />
                  <div v-if="serverErrors.description_en" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.description_en"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="ibox" :class="{ collapsed: !expandedSections.de }">
            <div class="ibox-title">
              <h5>Opis opcji [de]</h5>
              <div class="ibox-tools">
                <a class="collapse-link" @click="toggleSection('de')">
                  <i
                    :class="
                      expandedSections.de
                        ? 'fa fa-chevron-up'
                        : 'fa fa-chevron-down'
                    "
                  ></i>
                </a>
              </div>
            </div>

            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Etykieta</label>
                <div class="col-sm-10">
                  <input
                    v-model="optionData.label_de"
                    name="label_de"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Etykieta"
                  />
                  <div v-if="serverErrors.label_de" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.label_de"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Opis</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="optionData.description_de"
                  />
                  <div v-if="serverErrors.description_de" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.description_de"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="ibox" :class="{ collapsed: !expandedSections.cpde }">
            <div class="ibox-title">
              <h5>Opis opcji [de_de]</h5>
              <div class="ibox-tools">
                <a class="collapse-link" @click="toggleSection('cpde')">
                  <i
                    :class="
                      expandedSections.cpde
                        ? 'fa fa-chevron-up'
                        : 'fa fa-chevron-down'
                    "
                  ></i>
                </a>
              </div>
            </div>

            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Etykieta</label>
                <div class="col-sm-10">
                  <input
                    v-model="optionData.label_cpde"
                    name="label_cpde"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Etykieta"
                  />
                  <div v-if="serverErrors.label_cpde" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.label_cpde"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Opis</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="optionData.description_cpde"
                  />
                  <div v-if="serverErrors.description_cpde" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.description_cpde"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="ibox" :class="{ collapsed: !expandedSections.cpen }">
            <div class="ibox-title">
              <h5>Opis opcji [de_en]</h5>
              <div class="ibox-tools">
                <a class="collapse-link" @click="toggleSection('cpen')">
                  <i
                    :class="
                      expandedSections.cpen
                        ? 'fa fa-chevron-up'
                        : 'fa fa-chevron-down'
                    "
                  ></i>
                </a>
              </div>
            </div>

            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Etykieta</label>
                <div class="col-sm-10">
                  <input
                    v-model="optionData.label_cpen"
                    name="label_cpen"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Etykieta"
                  />
                  <div v-if="serverErrors.label_cpen" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.label_cpen"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Opis</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="optionData.description_cpen"
                  />
                  <div v-if="serverErrors.description_cpen" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.description_cpen"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-12">
          <div
            v-if="canViewTechLine"
            class="ibox"
            :class="{ collapsed: !expandedSections.tech }"
          >
            <div class="ibox-title">
              <h5>Linia technologiczna</h5>
              <div class="ibox-tools">
                <a class="collapse-link" @click="toggleSection('tech')">
                  <i
                    :class="
                      expandedSections.tech
                        ? 'fa fa-chevron-up'
                        : 'fa fa-chevron-down'
                    "
                  ></i>
                </a>
              </div>
            </div>

            <div class="ibox-content">
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="optionData.tech_lines_enabled"
                        name="tech_lines_enabled"
                        type="checkbox"
                      />
                      <span>Linie technologiczne</span>
                    </label>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">
                  Pozycja początkowa x
                </label>
                <div class="col-sm-10">
                  <input
                    v-model.number="optionData.tech_start_x"
                    name="tech_start_x"
                    type="number"
                    class="form-control inputClass"
                    placeholder="0"
                    :disabled="!optionData.tech_lines_enabled"
                  />
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">
                  Pozycja początkowa y
                </label>
                <div class="col-sm-10">
                  <input
                    v-model.number="optionData.tech_start_y"
                    name="tech_start_y"
                    type="number"
                    class="form-control inputClass"
                    placeholder="0"
                    :disabled="!optionData.tech_lines_enabled"
                  />
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">
                  Pozycja końcowa x *
                </label>
                <div class="col-sm-10">
                  <input
                    v-model.number="optionData.tech_end_x"
                    name="end_x"
                    type="number"
                    class="form-control inputClass"
                    placeholder="0"
                    :disabled="!optionData.tech_lines_enabled"
                  />
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">
                  Pozycja końcowa y *
                </label>
                <div class="col-sm-10">
                  <input
                    v-model.number="optionData.tech_end_y"
                    name="end_y"
                    type="number"
                    class="form-control inputClass"
                    placeholder="0"
                    :disabled="!optionData.tech_lines_enabled"
                  />
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Obrazek</label>
                <div class="col-sm-10">
                  <div class="col-sm-3">
                    <picture-input
                      ref="techPictureInput"
                      width="200"
                      height="200"
                      margin="16"
                      accept="image/jpeg,image/png,image/gif"
                      :crop="false"
                      size="10"
                      button-class="btn"
                      :prefill="optionData?.tech_image"
                      :disabled="!optionData.tech_lines_enabled"
                      :custom-strings="{
                        upload: '<h1>Uploading!</h1>',
                        drag: 'Drag & Drop',
                      }"
                      @change="changeTechPhoto"
                    >
                    </picture-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="ibox" :class="{ collapsed: !expandedSections.data }">
            <div class="ibox-title">
              <h5>Dane opcji</h5>
              <div class="ibox-tools">
                <a class="collapse-link" @click="toggleSection('data')">
                  <i
                    :class="
                      expandedSections.data
                        ? 'fa fa-chevron-up'
                        : 'fa fa-chevron-down'
                    "
                  ></i>
                </a>
              </div>
            </div>

            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Cena papier / kg</label>
                <div class="col-sm-10">
                  <input
                    v-model="optionData.paper_price"
                    name="paper_price"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Cena papier / kg"
                    required
                  />
                  <div v-if="serverErrors.paper_price" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.paper_price"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Wartość</label>
                <div class="col-sm-10">
                  <input
                    v-model="optionData.option_value"
                    name="option_value"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Wartość"
                  />
                  <div v-if="serverErrors.option_value" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.option_value"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Waga m2</label>
                <div class="col-sm-10">
                  <input
                    v-model="optionData.weight"
                    name="weight"
                    type="number"
                    class="form-control inputClass"
                    placeholder="Waga m2"
                    required
                  />
                  <div v-if="serverErrors.weight" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.weight"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Grubość (mm)</label>
                <div class="col-sm-10">
                  <input
                    v-model="optionData.thickness"
                    name="thickness"
                    type="number"
                    class="form-control inputClass"
                    placeholder="Grubość (mm)"
                    required
                  />
                  <div v-if="serverErrors.thickness" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.thickness"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Dni realizacji</label>
                <div class="col-sm-10">
                  <input
                    v-model="optionData.realization_days"
                    name="realization_days"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Dni realizacji"
                    required
                  />
                  <div v-if="serverErrors.realization_days" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.realization_days"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="optionData.group_together"
                        name="group_together"
                        type="checkbox"
                      />
                      <span>Grupuj produkty z opcją razem</span>
                    </label>
                  </div>
                  <div v-if="serverErrors.group_together" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.group_together"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="optionData.hidden_price"
                        name="hidden_price"
                        type="checkbox"
                      />
                      <span>Ukryj cenę</span>
                    </label>
                  </div>
                  <div v-if="serverErrors.hidden_price" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.hidden_price"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="optionData.show_on_production"
                        name="show_on_production"
                        type="checkbox"
                      />
                      <span>Pokaż na produkcji</span>
                    </label>
                  </div>
                  <div v-if="serverErrors.show_on_production" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.show_on_production"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="optionData.show_in_inteligent_filter"
                        name="show_in_inteligent_filter"
                        type="checkbox"
                      />
                      <span>Opcja widoczna w filtrowaniu inteligentnym</span>
                    </label>
                  </div>
                  <div
                    v-if="serverErrors.show_in_inteligent_filter"
                    class="has-error"
                  >
                    <span
                      class="help-block"
                      v-for="error in serverErrors.show_in_inteligent_filter"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="optionData.confirm_choice"
                        name="confirm_choice"
                        type="checkbox"
                        @change="onConfirmChoiceChange"
                      />
                      <span>Potwierdź wybór</span>
                    </label>
                  </div>
                  <div v-if="serverErrors.confirm_choice" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.confirm_choice"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Komunikat PL</label>
                <div class="col-sm-10">
                  <input
                    v-model="optionData.statement_pl"
                    name="statement_pl"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Komunikat PL"
                    :disabled="!optionData.confirm_choice"
                  />
                  <div v-if="serverErrors.statement_pl" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.statement_pl"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Komunikat DE</label>
                <div class="col-sm-10">
                  <input
                    v-model="optionData.statement_de"
                    name="statement_de"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Komunikat DE"
                    :disabled="!optionData.confirm_choice"
                  />
                  <div v-if="serverErrors.statement_de" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.statement_de"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Komunikat EN</label>
                <div class="col-sm-10">
                  <input
                    v-model="optionData.statement_en"
                    name="statement_en"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Komunikat EN"
                    :disabled="!optionData.confirm_choice"
                  />
                  <div v-if="serverErrors.statement_en" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.statement_en"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Komunikat DE [DE]</label>
                <div class="col-sm-10">
                  <input
                    v-model="optionData.statement_cpde"
                    name="statement_cpde"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Komunikat DE [DE]"
                    :disabled="!optionData.confirm_choice"
                  />
                  <div v-if="serverErrors.statement_cpde" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.statement_cpde"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Komunikat EN [DE]</label>
                <div class="col-sm-10">
                  <input
                    v-model="optionData.statement_cpen"
                    name="statement_cpen"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Komunikat EN [DE]"
                    :disabled="!optionData.confirm_choice"
                  />
                  <div v-if="serverErrors.statement_cpen" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.statement_cpen"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="optionData.enter_values_possible"
                        name="enter_values_possible"
                        type="checkbox"
                        @change="onEnterValuesPossibleChange"
                      />
                      <span>Opcja z możliwością wpisania wartości</span>
                    </label>
                  </div>
                  <div
                    v-if="serverErrors.enter_values_possible"
                    class="has-error"
                  >
                    <span
                      class="help-block"
                      v-for="error in serverErrors.enter_values_possible"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Wartość minimalna</label>
                <div class="col-sm-10">
                  <input
                    v-model="optionData.min_value"
                    name="min_value"
                    type="number"
                    class="form-control inputClass"
                    placeholder="Wartość minimalna"
                    :disabled="!optionData.enter_values_possible"
                  />
                  <div v-if="serverErrors.min_value" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.min_value"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Wartość maksymalna</label>
                <div class="col-sm-10">
                  <input
                    v-model="optionData.max_value"
                    name="max_value"
                    type="number"
                    class="form-control inputClass"
                    placeholder="Wartość maksymalna"
                    :disabled="!optionData.enter_values_possible"
                  />
                  <div v-if="serverErrors.max_value" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.max_value"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="optionData.applies_to_custom_format"
                        name="applies_to_custom_format"
                        type="checkbox"
                        @change="onAppliesToCustomFormatChange"
                        :disabled="!optionData.enter_values_possible"
                      />
                      <span>Wpisana wartość dotyczy dowolnego formatu</span>
                    </label>
                  </div>
                  <div
                    v-if="serverErrors.applies_to_custom_format"
                    class="has-error"
                  >
                    <span
                      class="help-block"
                      v-for="error in serverErrors.applies_to_custom_format"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div
                class="form-group"
                v-if="optionData.applies_to_custom_format"
              >
                <label class="control-label col-sm-2">Dotyczy</label>
                <div class="col-sm-10">
                  <div class="radio">
                    <label>
                      <input
                        v-model="optionData.custom_format_dimension"
                        name="custom_format_dimension"
                        type="radio"
                        value="long"
                        :disabled="!optionData.applies_to_custom_format"
                      />
                      Długiego boku
                    </label>
                  </div>
                  <div class="radio">
                    <label>
                      <input
                        v-model="optionData.custom_format_dimension"
                        name="custom_format_dimension"
                        type="radio"
                        value="short"
                        :disabled="!optionData.applies_to_custom_format"
                      />
                      Krótkiego boku
                    </label>
                  </div>
                  <div
                    v-if="serverErrors.custom_format_dimension"
                    class="has-error"
                  >
                    <span
                      class="help-block"
                      v-for="error in serverErrors.custom_format_dimension"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Obrazek</label>
                <div class="col-sm-10">
                  <div class="col-sm-3">
                    <picture-input
                      ref="pictureInput"
                      width="200"
                      height="200"
                      margin="16"
                      accept="image/jpeg,image/png,image/gif"
                      :crop="false"
                      size="10"
                      button-class="btn"
                      :prefill="optionData?.image"
                      :custom-strings="{
                        upload: '<h1>Uploading!</h1>',
                        drag: 'Drag & Drop',
                      }"
                      @change="changePhoto"
                    >
                    </picture-input>
                  </div>
                  <div v-if="serverErrors.image" class="has-error">
                    <span
                      class="help-block"
                      v-for="error in serverErrors.image"
                      :key="error"
                    >
                      {{ error }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-4 col-sm-offset-2">
                  <router-link
                    class="btn btn-white"
                    :to="`/product-option-group/${groupPk}/options`"
                  >
                    Anuluj
                  </router-link>
                  <button
                    v-if="canChangeOption"
                    class="btn btn-primary"
                    type="submit"
                  >
                    Zapisz
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { computed, ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { hasPermission } from "../../permissions";
import {
  productOptionPermissionsConst,
  techlinePermissionsConst,
} from "../../constants/productConstants";
import { useRoute, useRouter } from "vue-router";
import PictureInput from "vue-picture-input";
import { QuillEditor } from "@vueup/vue-quill";

export default {
  name: "ProductOptionEdit",
  components: {
    QuillEditor,
    PictureInput,
  },
  setup() {
    const store = useStore();
    const canChangeOption = computed(() =>
      hasPermission(productOptionPermissionsConst.update)
    );
    // The tech line is a separate model saved after the option itself - the old
    // panel hides its section without the view permission.
    const canViewTechLine = computed(() =>
      hasPermission(techlinePermissionsConst.view)
    );
    const route = useRoute();
    const router = useRouter();

    const optionPk = ref(Number(route.params.option_pk));
    const groupPk = ref(Number(route.params.group_pk));
    const groupName = ref("");

    const optionData = ref({
      options_group: groupPk.value,
      label_pl: "",
      label_en: "",
      label_de: "",
      label_cpde: "",
      label_cpen: "",
      description_pl: "",
      description_en: "",
      description_de: "",
      description_cpde: "",
      description_cpen: "",
      internal_description: "",
      paper_price: "",
      option_value: "",
      weight: "",
      thickness: "",
      realization_days: "",
      tech_lines_enabled: false,
      tech_start_x: 0,
      tech_start_y: 0,
      tech_end_x: 0,
      tech_end_y: 0,
      tech_image: null,
      group_together: false,
      hidden_price: false,
      show_on_production: false,
      show_in_inteligent_filter: false,
      confirm_choice: false,
      statement_pl: "",
      statement_de: "",
      statement_en: "",
      statement_cpde: "",
      statement_cpen: "",
      enter_values_possible: false,
      min_value: 0,
      max_value: 0,
      applies_to_custom_format: false,
      custom_format_dimension: "",
      image: null,
    });

    const serverErrors = ref({});
    const expandedSections = ref({
      pl: true, // PL section is expanded by default
      en: false,
      de: false,
      cpde: false,
      cpen: false,
      data: true, // Data section is expanded by default
      tech: true,
    });
    const optionDataFromStore = computed(() => store.getters.getOptionData);
    const updateOptionData = computed(() => store.getters.getUpdateOptionData);
    const pogData = computed(() => store.getters.getPOGData);

    const cleanErrors = (errors, field) => {
      if (errors[field]) {
        delete errors[field];
      }
    };

    const onConfirmChoiceChange = () => {
      cleanErrors(serverErrors.value, "confirm_choice");
      if (!optionData.value.confirm_choice) {
        optionData.value.statement_pl = "";
        optionData.value.statement_de = "";
        optionData.value.statement_en = "";
        optionData.value.statement_cpde = "";
        optionData.value.statement_cpen = "";
      }
    };

    const onEnterValuesPossibleChange = () => {
      cleanErrors(serverErrors.value, "enter_values_possible");
      if (!optionData.value.enter_values_possible) {
        optionData.value.min_value = "";
        optionData.value.max_value = "";
        optionData.value.applies_to_custom_format = false;
        optionData.value.custom_format_dimension = "";
      }
    };

    const onAppliesToCustomFormatChange = () => {
      cleanErrors(serverErrors.value, "applies_to_custom_format");
      if (!optionData.value.applies_to_custom_format) {
        optionData.value.custom_format_dimension = "";
      }
    };

    const toggleSection = (sectionName) => {
      expandedSections.value[sectionName] =
        !expandedSections.value[sectionName];
    };

    const changePhoto = (image) => {
      if (image.srcElement?.files[0]) {
        optionData.value.image = image.srcElement?.files[0];
      }
    };

    const changeTechPhoto = (image) => {
      if (image.srcElement?.files[0]) {
        optionData.value.tech_image = image.srcElement?.files[0];
      }
    };

    const updateOption = async () => {
      if (!canChangeOption.value) {
        return;
      }
      // Jeśli image to string (URL istniejącego obrazka), usuń go z obiektu
      if (typeof optionData.value.image === "string") {
        delete optionData.value.image;
      }

      const dataToSend = {
        ...optionData.value,
        tech_line: optionData.value.tech_lines_enabled ? 1 : 0,
        // Jawnie ustawiamy enter_values_possible jako 0 lub 1
        enter_values_possible: optionData.value.enter_values_possible ? 1 : 0,
        group_together: optionData.value.group_together ? 1 : 0,
        hidden_price: optionData.value.hidden_price ? 1 : 0,
        show_on_production: optionData.value.show_on_production ? 1 : 0,
        show_in_inteligent_filter: optionData.value.show_in_inteligent_filter
          ? 1
          : 0,
        confirm_choice: optionData.value.confirm_choice ? 1 : 0,
      };
      delete dataToSend.tech_lines_enabled;

      // Jeśli enter_values_possible jest false, wyzeruj powiązane pola
      if (!optionData.value.enter_values_possible) {
        dataToSend.min_value = 0;
        dataToSend.max_value = 0;
        dataToSend.applies_to_custom_format = 0;
        dataToSend.custom_format_dimension = "";
      } else {
        dataToSend.applies_to_custom_format = optionData.value
          .applies_to_custom_format
          ? 1
          : 0;
      }

      await store.dispatch("updateOption", {
        pk: optionPk.value,
        data: dataToSend,
      });

      // An existing tech line is updated, a missing one is created.
      const techLinePermission = optionData.value.tech_line_pk
        ? techlinePermissionsConst.update
        : techlinePermissionsConst.add;
      if (optionData.value.tech_lines_enabled) {
        if (!hasPermission(techLinePermission)) {
          store.dispatch("showToaster", {
            type: "error",
            content: techLinePermission.errorMsg,
          });
          return;
        }
        await store.dispatch("upsertProductOptionTechLine", {
          pk: optionData.value.tech_line_pk, // opcjonalnie, jeśli istnieje
          option: optionPk.value,
          start_x: Number(optionData.value.tech_start_x) || 0,
          start_y: Number(optionData.value.tech_start_y) || 0,
          end_x: Number(optionData.value.tech_end_x) || 0,
          end_y: Number(optionData.value.tech_end_y) || 0,
          image: optionData.value.tech_image,
        });
      } else if (
        optionData.value.tech_line_pk &&
        hasPermission(techlinePermissionsConst.delete)
      ) {
        await store.dispatch("deleteProductOptionTechLine", {
          pk: optionData.value.tech_line_pk,
        });
      }
    };

    const fetchOption = async () => {
      await store.dispatch("getOption", optionPk.value);
    };

    const fetchGroup = async () => {
      await store.dispatch("getPOG", { pk: groupPk.value });
    };

    onMounted(() => {
      fetchOption();
      fetchGroup();
    });

    watch(
      () => pogData.value,
      function (newValue) {
        if (newValue && newValue.data) {
          groupName.value = newValue.data.name_pl || "";
        }
      }
    );

    watch(
      () => optionDataFromStore.value,
      function (newValue) {
        if (newValue && newValue.data) {
          const data = newValue.data;

          optionData.value = {
            options_group: groupPk.value,
            label_pl: data.label_pl || "",
            label_en: data.label_en || "",
            label_de: data.label_de || "",
            label_cpde: data.label_cpde || "",
            label_cpen: data.label_cpen || "",
            description_pl: data.description_pl || "",
            description_en: data.description_en || "",
            description_de: data.description_de || "",
            description_cpde: data.description_cpde || "",
            description_cpen: data.description_cpen || "",
            internal_description: data.internal_description || "",
            paper_price: data.paper_price || "",
            option_value: data.option_value || "",
            weight: data.weight || "",
            thickness: data.thickness || "",
            realization_days: data.realization_days || "",
            tech_line_pk: data.tech_line_object?.pk || null,
            tech_lines_enabled: Boolean(
              data.tech_line_object ||
                data.tech_line ||
                data.has_tech_line ||
                data.tech_start_x ||
                data.tech_start_y ||
                data.tech_end_x ||
                data.tech_end_y ||
                data.end_x ||
                data.end_y
            ),
            tech_start_x:
              data.tech_line_object?.start_x ?? data.tech_start_x ?? 0,
            tech_start_y:
              data.tech_line_object?.start_y ?? data.tech_start_y ?? 0,
            tech_end_x:
              data.tech_line_object?.end_x ??
              data.tech_end_x ??
              data.end_x ??
              0,
            tech_end_y:
              data.tech_line_object?.end_y ??
              data.tech_end_y ??
              data.end_y ??
              0,
            tech_image: data.tech_line_object?.image || null,
            group_together: Boolean(Number(data.group_together)),
            hidden_price: Boolean(Number(data.hidden_price)),
            show_on_production: Boolean(Number(data.show_on_production)),
            show_in_inteligent_filter: Boolean(
              Number(data.show_in_inteligent_filter)
            ),
            confirm_choice: Boolean(Number(data.confirm_choice)),
            statement_pl: data.statement_pl || "",
            statement_de: data.statement_de || "",
            statement_en: data.statement_en || "",
            statement_cpde: data.statement_cpde || "",
            statement_cpen: data.statement_cpen || "",
            enter_values_possible: Boolean(Number(data.enter_values_possible)),
            min_value: data.min_value || "",
            max_value: data.max_value || "",
            applies_to_custom_format: Boolean(
              Number(data.applies_to_custom_format)
            ),
            custom_format_dimension: data.custom_format_dimension || "",
            image: data.image || null,
          };
        }
      }
    );

    watch(
      () => updateOptionData.value,
      function (newValue) {
        if (newValue) {
          if (newValue.status === 200) {
            store.dispatch("showToaster", {
              type: "success",
              content: "Opcja została zaktualizowana",
            });
            router.push(`/product-option-group/${groupPk.value}/options`);
          } else {
            serverErrors.value = newValue.data || {};
            store.dispatch("showToaster", {
              type: "error",
              content: "Wystąpił błąd podczas aktualizacji opcji",
            });
          }
        }
      }
    );

    const updateTechLineData = computed(
      () => store.getters.getUpdateTechLineData
    );

    watch(
      () => updateTechLineData.value,
      function (newValue) {
        if (newValue) {
          if (newValue.status === 200 || newValue.status === 201) {
            // Tech line zaktualizowana pomyślnie
            // Nie pobieramy ponownie danych, bo i tak następuje przekierowanie
          }
        }
      }
    );

    return {
      canChangeOption,
      canViewTechLine,
      optionData,
      serverErrors,
      groupPk,
      groupName,
      expandedSections,
      updateOption,
      cleanErrors,
      onConfirmChoiceChange,
      onEnterValuesPossibleChange,
      onAppliesToCustomFormatChange,
      changePhoto,
      changeTechPhoto,
      toggleSection,
    };
  },
};
</script>
